import { ReactComponent as EyeOff } from 'assets/eye-off.svg';
import { ReactComponent as Eye } from 'assets/eye.svg';
import { useState } from 'react';
import { FieldError } from 'react-hook-form';
import ForwardRefInput, { ForwardRefInputProps } from './ForwardRefInput';

const PasswordWithEye = ({
  register,
  errorsName,
  size = 'max-w-xs',
  placeholder,
  disabled,
  cssType,
  autoFocus = false,
}: {
  register: ForwardRefInputProps;
  errorsName: FieldError | undefined;
  size?: string;
  placeholder?: string;
  disabled?: boolean;
  cssType?: React.CSSProperties;
  autoFocus?: boolean;
}) => {
  const [passwordType, setPasswordType] = useState<'text' | 'password'>('password');
  const togglePassword = () => {
    passwordType === 'password' ? setPasswordType('text') : setPasswordType('password');
  };

  return (
    <div className={`flex ${size} ${disabled ? 'bg-gray-100' : 'bg-white'} border rounded border-gray-800 border-opacity-20`} style={cssType}>
      <ForwardRefInput
        className={`input input-eye flex-1 text-sm` + (errorsName ? ' input-error' : '')}
        placeholder={placeholder}
        type={passwordType}
        {...register}
        disabled={disabled}
        style={cssType}
        autoFocus={autoFocus}
      />
      <button type="button" className="mx-2" onClick={togglePassword}>
        {passwordType === 'password' ? <EyeOff className="w-4 h-4 text-cyfi-btn" /> : <Eye className="w-4 h-4 text-cyfi-btn" />}
      </button>
    </div>
  );
};

export default PasswordWithEye;
